import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c14ead5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-dms-wrapper" }
const _hoisted_2 = { class: "app-dms" }
const _hoisted_3 = {
  key: 5,
  ref: "labelPopup",
  class: "label-input-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-bottom" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "label-input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-input__title" }, "Label:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_media_view_header = _resolveComponent("drive-media-view-header")!
  const _component_drive_media_view_slide = _resolveComponent("drive-media-view-slide")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_drive_media_view_nav = _resolveComponent("drive-media-view-nav")!
  const _component_media_settings_pop_up = _resolveComponent("media-settings-pop-up")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_app_rename_file = _resolveComponent("app-rename-file")!
  const _component_drive_cropper = _resolveComponent("drive-cropper")!
  const _component_app_label_input = _resolveComponent("app-label-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_drive_media_view_header, {
      title: _ctx.mediaList[_ctx.currentMedia]?.name,
      onOnClickBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-close'))),
      onOnClickShare: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSharePopUp = true)),
      onOnClickDots: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMediaSettingsPopUp = true)),
      onOnVisitChat: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-close')))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper, {
        ref: "mySwiper",
        navigation: "",
        "initial-slide": _ctx.initialSlide,
        "edge-swipe-threshold": 50,
        "long-swipe-ratio": 1.5,
        "slides-per-view": 1,
        "space-between": 0,
        "preload-images": false,
        lazy: true,
        modules: _ctx.modules,
        onSwiper: _ctx.onSwiper,
        onSlideChange: _ctx.onSlideChange,
        onToEdge: _ctx.onReachEnd
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.swiper.slideNext()))
          }, "Slide to the next slide"),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaList, (media) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: media.contentId
            }, {
              default: _withCtx(() => [
                _createVNode(_component_drive_media_view_slide, {
                  media: media!,
                  currentMedia: _ctx.driveStore.appPhotoViewMedia,
                  pauseVideo: _ctx.pauseVideo,
                  onIfVideoPaused: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pauseVideo = false))
                }, null, 8, ["media", "currentMedia", "pauseVideo"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["initial-slide", "long-swipe-ratio", "modules", "onSwiper", "onSlideChange", "onToEdge"]),
      (_ctx.showSkeleton)
        ? (_openBlock(), _createBlock(_component_app_skeleton_rect, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_drive_media_view_nav, {
      title: _ctx.mediaList[_ctx.currentMedia]?.name,
      "current-type": _ctx.currentItemType,
      file: _ctx.currentItem!,
      onOnShare: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSharePopUp = true)),
      onOnInfo: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openPopUp(_ctx.mediaList[_ctx.currentMedia]?.type === 'PHOTO' ? _ctx.BOTTOM_POPUP_TYPES.PHOTO_INFO : _ctx.BOTTOM_POPUP_TYPES.FILE_INFO))),
      onOnLabels: _ctx.openLabelsPopup,
      onOnEdit: _ctx.openCropper,
      onOnViewMore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMediaSettingsPopUp = true)),
      onPositionData: _ctx.getPosition
    }, null, 8, ["title", "current-type", "file", "onOnLabels", "onOnEdit", "onPositionData"]),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_media_settings_pop_up, {
          key: 0,
          file: _ctx.currentItem!,
          type: _ctx.currentItemType,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onCloseMedia: _cache[10] || (_cache[10] = ($event: any) => (_ctx.driveStore.appPhotoViewMedia = undefined)),
          onOpenMovePopUp: _ctx.openMovePopUp,
          onDeleteMedia: _ctx.openQuestionPopUp,
          onSaveMediaAsCopy: _ctx.saveMediaAsCopy,
          onOpenFileRenamePopUp: _cache[11] || (_cache[11] = ($event: any) => (_ctx.fileRenamePopUp = true))
        }, null, 8, ["file", "type", "onOpenMovePopUp", "onDeleteMedia", "onSaveMediaAsCopy"]))
      : _createCommentVNode("", true),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 1,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deletePhoto
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isSharePopUp)
      ? (_openBlock(), _createBlock(_component_share_pop_up, {
          key: 2,
          item: _ctx.currentItem!,
          "item-type": _ctx.currentItemType,
          onHide: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSharePopUp = false)),
          onSetItemShared: _ctx.setItemShared,
          onSetSharedLabels: _ctx.setSharedLabels,
          onOnShareByMessage: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('on-close'))),
          class: "share-popup"
        }, null, 8, ["item", "item-type", "onSetItemShared", "onSetSharedLabels"]))
      : _createCommentVNode("", true),
    (_ctx.isMoveToPopUp)
      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
          key: 3,
          item: _ctx.currentItem,
          "item-type": _ctx.currentItemType,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isMoveToPopUp = false)),
          onUpdateLocation: _ctx.updateLocation
        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
      : _createCommentVNode("", true),
    (_ctx.fileRenamePopUp)
      ? (_openBlock(), _createBlock(_component_app_rename_file, {
          key: 4,
          file: _ctx.currentItem,
          "mount-error-info": _ctx.renameMountErrorInfo,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.fileRenamePopUp = false)),
          onClearMountErrorInfo: _cache[17] || (_cache[17] = ($event: any) => (_ctx.renameMountErrorInfo = undefined))
        }, null, 8, ["file", "mount-error-info"]))
      : _createCommentVNode("", true),
    _createVNode(_component_drive_cropper, {
      title: _ctx.mediaList[_ctx.currentMedia]?.name,
      image: _ctx.image,
      onOnCrop: _ctx.handleOnCrop,
      onOnCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.image = {})),
      "is-case-cropper": "",
      ref: "cropperRef",
      canvas: false
    }, null, 8, ["title", "image", "onOnCrop"]),
    (_ctx.showAddLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", {
            class: "label-input-close",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.cancelLabelsPopup && _ctx.cancelLabelsPopup(...args)))
          }, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_app_label_input, {
              onOnInputDone: _ctx.addLabelsClose,
              class: "label-input__input",
              "show-done-control": "",
              "is-file": _ctx.isFile,
              "is-photo": _ctx.isPhoto,
              "is-app-media-view": "",
              focus: ""
            }, null, 8, ["onOnInputDone", "is-file", "is-photo"])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}